import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').component('imDoubleSelect', {
        template: require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/forms/double-select/double-select.html'),
        controller: 'DoubleSelectController',
        controllerAs: 'DoubleSelectCtrl',
        bindings: {
            options: '<',
            selected: '=',
        },
    });
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/forms/double-select/double-select.component.ts